/*
 * @Author: JamesWong
 * @Description: 副屏幕中文包
 * @Date: 2018-11-30 10:09:38
 * @Last Modified by: JamesWong
 * @Last Modified time: 2018-11-30 17:02:20
 */
export default {
  interactMode: '交互模式',
  rollingPhotos: '輪播圖片',
  advertisementVideo: '廣告視頻',
  interactModeTips1: '1.收銀機沒有進行收銀操作時，副屏全屏顯示圖片輪播/視頻輪播',
  interactModeTips2: '2.收銀過程中，副螢幕左側顯示圖片/視頻，右側顯示銷售明細及交易金額',
  interactModeTips3: '3.結算完成後，副螢幕再次恢復全屏模式',
  fullscreenPhoto: '全屏圖片',
  fullscreenVideo: '全屏視頻',
  photoSalesDetail: '圖片 + 銷售明細',
  videoSalesDetail: '視頻 + 銷售明細',
  upload: '上傳',
  preview: '預覽',
  previewPhotos: '預覽圖片',
  delete: '刪除',
  photoDeleted: '圖片刪除成功',
  previewVideo: '預覽視頻',
  videoUploaded: '上傳視頻成功！',
  videoSizeTips: '檔大小不能超過200M！',
  photoUploaded: '上傳圖片成功！',
  phoneSizeTips: '檔大小不能超過10M！',
  longNameTips: '檔案名不能過長！',
  moreFileTips: '最多只能上傳一個視頻，請先刪除原有的視頻再嘗試上傳！',
  uploadingTips: '文件正在上傳中...   請稍等',
  notSupportTips: '您的流覽器不支持 video 標籤。',
  uploadProgress: '上傳進度',
  noVideoTips: '你還沒有上傳視頻，趕快上傳吧',
  noPhotoTips: '你還沒有上傳圖片，趕快上傳吧',
  Unnamed: '未命名'
}


// WEBPACK FOOTER //
// ./src/i18n/zh-hant/screen.js